import React, {useEffect, useState} from "react";

import './Patient.detail.kit.scss';
import {getDateFormat} from "../../utils/date";

export default function KitEntry({currentOrg, value}) {
    const [peripherial, setPeripherial] = useState('');
    const [devices, setDevices] = useState([]);

    useEffect(() => {
        setPeripherial(value);
        let _devices = {};
        value.devices.map((device) => {
            if(device.name in _devices){
                _devices[device.name]["deviceIds"].push(device.deviceId);
            }else{
                _devices[device.name] = {
                    "name": device.name,
                    "deviceIds": [device.deviceId]
                };
            }
        });
        setDevices(Object.values(_devices));
    }, [value]);

    if(!peripherial){
        return '';
    }

    const getAction = (action) => {
        if (action === 'assigned') {
            return 'Assigned';
        }
        if (action === 'unAssigned') {
            return 'UnAssigned';
        }
        return action;
    }

    return (
        <div className="_kit">
            <div className="_kit_info">
                <div className="_kit_name">{ peripherial.isKit? '1 Kit ID ': ''} <b>{ peripherial.isKit? peripherial.kitId : peripherial.name}</b></div>
                <div className="_kit_date">
                    {
                        peripherial.status.map((s, i) => (
                            <div key={'action-'+peripherial.deviceId+'-'+i} className={`${(peripherial.status.length === i+1) ? 'bold' : ''}`}>
                                <span key={'action'+i}>{getAction(s.action)}:</span>
                                <span key={'date-'+i}>{getDateFormat(currentOrg, s.dateCreated, 'long')}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
            <div className="_devices">
                {
                    devices.map((item, index) => (
                        <div key={index} className="_device">
                            <div className="_name">{ item.name }</div>
                            {
                                item.deviceIds.map((deviceID, _index) => (
                                    <div key={_index} className="_device">
                                        <div className="_id">{ _index === 0?'ID ': '\u00a0\u00a0\u00a0\u00a0'} {deviceID}</div>
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
